<template>
  <b-row>
    <b-col lg="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col lg="7">
            <h4 id="traffic" class="card-title mb-0">Cupones de Descuentos</h4>
            <div class="small text-muted">Administrar todos los cupones de descuentos disponibles para usar en la tienda</div>
          </b-col>

          <b-col lg="5">
            <b-button @click="add()" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Cupón de Descuentos">
              <i class="fa fa-plus"></i> Agregar
            </b-button>
          </b-col>          
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-table class="mb-0"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    v-if="table.items.length">

                <template v-slot:cell(id)="data">
                  <b>{{ data.item.id }}</b>
                </template>
              
                <template v-slot:cell(name)="data">
                  {{ data.item.name }}
                </template>

                <template v-slot:cell(code)="data">
                  <b>{{ data.item.code.toUpperCase() }}</b>
                </template>                              

                <template v-slot:cell(percentage)="data">
                  <div v-if="data.item.percentage>0">
                    {{ data.item.percentage }}%
                  </div>
                </template>

                <template v-slot:cell(price)="data">
                  <div v-if="data.item.price>0">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(data.item.price)}}
                  </div>
                </template>                

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">
                    <b-dropdown-item @click="edit(data.item)">
                      <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>

          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(table.items)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col>          
        </b-row>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white">
        <div slot="modal-header">
          {{this.modal.form.title}}
        </div>

        <b-row>
          <b-col lg="12">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>                                              
          </b-col>   
          <b-col lg="12">
            <b-form-group label="Código">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.code"
                            required
                            placeholder="Ingresar un código">
              </b-form-input>
            </b-form-group>                                              
          </b-col>             
          <b-col lg="6">
            <b-form-group label="Porcentaje" description="Descuenta el porcentaje sobre el total de la compra (%)">
              <b-form-input type="number"
                            size="sm"
                            step="0.01"
                            v-model="crud.form.percentage"
                            required
                            placeholder="Ingresar un porcentaje">
              </b-form-input>
            </b-form-group>                                              
          </b-col>   
          <b-col lg="6">
            <b-form-group label="Precio" description="Descuenta un monto fijo sobre el total de la compra ($)">
              <b-form-input type="number"
                            size="sm"
                            step="0.01"
                            v-model="crud.form.price"
                            required
                            placeholder="Ingresar un precio">
              </b-form-input>
            </b-form-group>                                              
          </b-col>                                                  
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>          
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import Imagen from '@/components/inc/image/image'

  export default {
    components: {
      Imagen,
    },         
    data: () => {
      return {      
        access: {
          module_id: Modules.CONTENIDOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudStoreDiscounts',
          elements: {}
        }, 
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', sortable: true, class:"align-middle"},
            {key: 'name', label: 'Nombre', class:"align-middle"},            
            {key: 'code', label: 'Código', class:"align-middle"},            
            {key: 'percentage', label: 'Porcentage', class:"align-middle"},                        
            {key: 'price', label: 'Precio', class:"align-middle"},                        
            {key: 'f_action', label:'', class:"align-middle"},
          ],
          currentPage: 1,
          perPage: 50,
        },
        crud: {
          form: {
            id: 0,
            name: '',
            code: '',
            percentage: 0,       
            price: 0,      
          },          
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },     
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.load()
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      load() {
        var result = serviceAPI.obtenerDescuentosTienda()

        result.then((response) => {
          var data = response.data
          this.table.items = data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.code = ''
        this.crud.form.percentage = 0
        this.crud.form.price = 0

        this.modal.form.title = "Nuevo Cupón de descuento"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.code = item.code
        this.crud.form.percentage = item.percentage
        this.crud.form.price = item.price

        this.modal.form.title = "Editar Cupón de descuento"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.$bvModal.msgBoxConfirm('¿Desea borrar el cupón de descuento (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Cupón de Descuento',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarDescuentosTienda(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        if(this.crud.form.percentage>0 && this.crud.form.price>0) {
          this.$awn.alert("Cargue solo una opción entre porcentaje y precio")
          return false
        } else {
          if(this.crud.form.percentage==0 && this.crud.form.price==0) {
            this.$awn.alert("Cargue una opción entre porcentaje y precio")
            return false            
          }
        }

        let loader = this.$loading.show();

        if (this.crud.form.id) {
          var result = serviceAPI.editarDescuentosTienda(this.crud.form);
        } else {
          var result = serviceAPI.agregarDescuentosTienda(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
    }    
  }
</script>